import Helper from '@ember/component/helper';
import { service } from '@ember/service';

export default class FindFeed extends Helper {
  @service feeds;

  compute(_positionalParams, hash = {}) {
    let foundFeed = this.feeds.feeds.find(feed => feed.matches(hash));
    // console.log('looking for feed ', hash)
    // console.log('found: ', foundFeed)

    return foundFeed;
  }
}
